var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#CFCFCF;}\n\t.st2{fill:none;stroke:#BABABA;stroke-width:2.18;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.18;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.3,107.1c-18.3,0-36.8-0.7-54.2-5.6c-17-4.7-32.7-13.9-46.7-24.5C98.3,70.1,90,64.6,78.1,65.4 c-11.6,0.6-22.7,5-31.6,12.4c-15.1,13.2-12.8,37.6-6.8,54.8c9.1,25.9,36.7,43.9,60.1,55.6c27.1,13.5,56.9,21.3,86.7,25.9 c26.2,4,59.8,6.9,82.4-10.2c20.8-15.7,26.6-51.6,21.5-75.8c-1.2-7.2-5.1-13.6-10.7-18.1c-14.6-10.7-36.4-3.6-52.9-3.2 C220.7,107.1,214.5,107.1,208.3,107.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.6,256.6c44.2,0,80-2.2,80-5c0-2.8-35.8-5-80-5c-44.2,0-80,2.2-80,5C83.6,254.4,119.4,256.6,163.6,256.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.6,9.4c1.2,0,2.1-1,2.1-2.1s-1-2.1-2.1-2.1c-1.2,0-2.1,1-2.1,2.1S203.5,9.4,204.6,9.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107,216.8c1.2,0,2.1-1,2.1-2.1s-1-2.1-2.1-2.1c-1.2,0-2.1,1-2.1,2.1S105.8,216.8,107,216.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.8,227.7v9.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.1,232.4h9.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.2,17.5c-23.1,0-45.3,9.2-61.7,25.5C82.2,59.4,73,81.6,73,104.7c0,64,87.2,123.9,87.2,123.9 s87.2-59,87.2-123.9c0-23.1-9.2-45.3-25.5-61.7C205.5,26.7,183.3,17.5,160.2,17.5z M160.2,137.4c-6.8,0-13.4-2-19.1-5.8 c-5.6-3.8-10.1-9.1-12.7-15.4c-2.6-6.3-3.3-13.2-2-19.8c1.3-6.7,4.6-12.8,9.4-17.6c4.8-4.8,10.9-8.1,17.6-9.4 c6.7-1.3,13.6-0.7,19.8,1.9c6.3,2.6,11.7,7,15.4,12.6c3.8,5.6,5.8,12.3,5.8,19.1c0,9.1-3.6,17.8-10.1,24.3S169.3,137.3,160.2,137.4 L160.2,137.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.9,33.6V43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.2,38.3h9.4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.1,59.2v9.4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.4,63.8h9.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.8,90.2l-23.2,23.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.6,90.2l23.2,23.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocation);
export default __webpack_public_path__ + "static/media/no-location.8f231e18fcf7b865ee44ebb0f1b62685.svg";
export { ForwardRef as ReactComponent };